import { classes } from 'html-classes';
import { useState } from 'react';

// import EVENT_IMAGE from '../../assets/img/temp/upcomming-1.png';
import Icon from '../../components/Icon/Icon';
import MainSidebar from '../../components/MainSidebar/MainSidebar';

import MobileHeaderLayout from '../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../Main/MobileHeader/MobileHeaderTitle';

import styles from './Subscription.module.scss';

const Subscription = () => {
  const [current, setCurrent] = useState(1);

  return (
    <>
      <MobileHeaderLayout
        content={<MobileHeaderTitle text="Subscriptions" />}
      />
      <div className="content-layout">
        <div className={classes(['content subscription', styles.container])}>
          <aside className="sidebar">
            <MainSidebar />
          </aside>

          <main className="container">
            <div className={classes(['title-wrapper', styles.titleWrapper])}>
              <button className="button _no-padding _no-color">
                <Icon type="arrow" size={24} className="icon__rotate-180" />
              </button>
              <div className="title">Subscriptions</div>
              <div className="badge">3</div>
            </div>

            <section className="tools-btn">
              <div className="text-wrapper">
                <div
                  className={classes(['left-btn', current === 1 && 'active'])}
                  onClick={() => setCurrent(1)}
                >
                  Current
                </div>
                <div
                  className={classes(['right-btn', current === 2 && 'active'])}
                  onClick={() => setCurrent(2)}
                >
                  Expired
                </div>
              </div>
            </section>

            <section className="subscriptions">
              <div className="content-wrapper">
                <div className="items">
                  <div className="item item1">
                    <div className="item-bg">
                      {/* <img alt="" src={EVENT_IMAGE} className="image" /> */}
                    </div>
                    <div className="top-block">
                      <div className="text-wrapper">
                        <div className="text">Next delivery (2/3)</div>
                        <div className="date">APR 19</div>
                      </div>
                    </div>
                    <div className="bottom-block">
                      <div className="text-wrapper">
                        <div className="text">Three Month Gin Subscription</div>
                      </div>
                    </div>
                  </div>
                  <div className="item item2">
                    <div className="item-bg">
                      {/* <img alt="" src={EVENT_IMAGE} className="image" /> */}
                    </div>
                    <div className="top-block">
                      <div className="text-wrapper">
                        <div className="text">Next delivery (2/3)</div>
                        <div className="date">APR 19</div>
                      </div>
                    </div>
                    <div className="bottom-block">
                      <div className="text-wrapper">
                        <div className="text">Three Month Gin Subscription</div>
                      </div>
                    </div>
                  </div>
                  <div className="item item3">
                    <div className="item-bg">
                      {/* <img alt="" src={EVENT_IMAGE} className="image" /> */}
                    </div>
                    <div className="top-block">
                      <div className="text-wrapper">
                        <div className="text">Next delivery (2/3)</div>
                        <div className="date">APR 19</div>
                      </div>
                    </div>
                    <div className="bottom-block">
                      <div className="text-wrapper">
                        <div className="text">Three Month Gin Subscription</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/*<CarouselContainer title="Recommended" />*/}
          </main>
        </div>
      </div>
    </>
  );
};

export default Subscription;
